export default "__VITE_ASSET__59b1ba94__"